import _ from 'lodash';
import { kgToSellingUnitQuantity } from './kgToSellingUnitQuantity';

export function ordersArrayForReturnItem(invoiceDetails: any, cnDetails: any): { callOffs: any[], orders: any[], allFG: any[] } {
  const value = cnDetails.value/(1+cnDetails.vatPercentage);
  if(invoiceDetails.orders.length > 0) {
    const returnedOrder = _.find(invoiceDetails.orders, (order: any) => _.get(order,'id._id') == _.get(cnDetails, 'goodsObjectOrder'));
    const quantity = cnDetails.goodsObjectQuantity;
    const fg = _.find(invoiceDetails.allFG, (fg: any) => fg._id == _.get(cnDetails,'goodsObject._id'));
    const updatedOrder = { ...returnedOrder, value, quantity, additionalCharges: 0 };
    return { orders: [updatedOrder], allFG: [fg], callOffs: [] };
  } else if(invoiceDetails.callOffs.length > 0) {
    const returnedCalloffItem = invoiceDetails.callOffs.find((callOffItem: any) => _.get(callOffItem, 'callOff._id') == cnDetails.callOffId);
    const quantityInKg = cnDetails.goodsObjectQuantity;
    const fg = _.get(cnDetails,'goodsObject', {});
    const quantityInSellingUnit = kgToSellingUnitQuantity(_.get(returnedCalloffItem, 'callOff'), fg, quantityInKg);
    const updatedCallOff = { ...returnedCalloffItem, value, quantity: quantityInSellingUnit, additionalCharges: 0 };
    return { callOffs: [updatedCallOff], allFG: [], orders: [] };
  } else {
    return { callOffs: [], orders: [], allFG: []};
  }
}